import {Authorizations, hasAuthorization} from "utils/authorizations";

export function canAccessEnrichment(authorizations, organization) {
    return true === organization?.enrichmentSuggestionEnabled
        && hasAuthorization(authorizations, Authorizations.MARKETPLACE_PRODUCT_ENRICH);
}
